import { z } from 'zod';

export const TargetIdSchema = z.string().brand('TargetId');
export type TargetId = z.infer<typeof TargetIdSchema> | string;

/**
 * Represents the interface for a target (usually a website) that can be scanned or monitored
 */
export interface ITarget {
    /**
     * The unique id of the target
     */
    id: TargetId;
    /**
     * The name of website to scan / monitor
     */
    name: string;
    /**
     * The corresponding url of the website
     */
    url: string;
}
